export const siteSettings = {
  name: "BitBlofin",
  link: "https://bitblofin.net",
  email: "support@bitblofin.net",
  appLink: "https://app.bitblofin.net",
};
